var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddFolderWhiteColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5602 25.875H15.3519C9.65574 25.875 6.80768 25.875 5.03812 24.1054C3.26855 22.3359 3.26855 19.4878 3.26855 13.7917V10.0993C3.26855 7.90443 3.26855 6.80697 3.72811 5.98349C4.05569 5.39649 4.54005 4.91213 5.12704 4.58455C5.95052 4.125 7.04798 4.125 9.24288 4.125C10.6491 4.125 11.3522 4.125 11.9677 4.3558C13.3729 4.88277 13.9524 6.15933 14.5865 7.42753L15.3519 8.95833M10.5186 8.95833H21.0915C23.6371 8.95833 24.9098 8.95833 25.8241 9.56925C26.22 9.83373 26.5598 10.1736 26.8243 10.5694C27.4106 11.4468 27.4343 12.6544 27.4352 15",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6019 16.2083V25.8749M27.4352 21.0416H17.7686",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFolderWhiteColor);
export default __webpack_public_path__ + "static/media/add-folder-whiteColor.4ae54d0e6c5cd99641b5064e34a1c514.svg";
export { ForwardRef as ReactComponent };